module.exports = __webpack_public_path__ + "img/user.0cfa14d3.svg";